import React from 'react';
import { Divider, Typography, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import useStyles from './styles';
import logo from '../../../../assets/Images/eedit.png';
import './style.css';

export default function Footer() {
  const classes = useStyles();
  const currentYear = new Date().getFullYear(); // Get the current year dynamically

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* First Column */}
        <div className="footer-column1">
          <img src={logo} alt="Logo" className="logo" />
          <div className="content-description">
            <p>
              We are thrilled to have you here. CineBooking is your ultimate
              destination for all your movie booking needs. Whether you're
              looking to catch the latest blockbuster, enjoy a classic film, or
              discover indie gems, we've got you covered. Our user-friendly
              platform ensures a seamless and enjoyable experience, from
              browsing movie listings to securing your tickets.
            </p>
          </div>
          <div className="social-links">
            <a href="#">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>
            {/* <a href="#">
              <i className="fab fa-linkedin-in"></i>
            </a> */}
          </div>
        </div>

        {/* Second Column */}
        <div className="footer-column2">
          {/* First Row */}
          <div className="footer-row">
            {/* Phone */}
            <div className="footer-column3">
              <div className="icon-container phone">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <h4>Phone</h4>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href="https://wa.me/+94777856980">
                  +94 77 785 6980
                </a>
              </div>
            </div>
            {/* Address */}
            <div className="footer-column3">
              <div className="icon-container">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <h4>Address</h4>
                <p>Jaffna, Sri lanka</p>
              </div>
            </div>
            {/* Email */}
            <div className="footer-column3">
              <div className="icon-container">
                <i className="far fa-envelope"></i>
              </div>
              <div>
                <h4>Email</h4>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href="mailto:support@cinebooking.lk">
                  Support@cinebooking.lk
                </a>
              </div>
            </div>
          </div>

          <hr className="row-divider" />

          {/* Second Row */}
          <div className="footer-row">
            <div className="footer-column4">
              <h4 class="h4">Company</h4>
              <ul className="footer-list">
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <span class="icon-text">Home</span>
                </li>
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <span class="icon-text">Now Showing</span>
                </li>
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <span class="icon-text">Coming Soon</span>
                </li>
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <span class="icon-text">Contact Us</span>
                </li>
              </ul>
            </div>
            <div className="footer-column4">
              <h4 class="h4">Legal</h4>
              <ul className="footer-list">
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <RouterLink to="/privacy-policy" class="icon-text footer-policy-link">Privacy Policy</RouterLink>
                </li>
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <RouterLink to="/terms-and-conditions" class="icon-text footer-policy-link">Terms &amp; Conditions</RouterLink>
                </li>
                <li>
                  <i class="fas fa-dot-circle company-icon"></i>
                  <RouterLink to="/return-refund-policy" class="icon-text footer-policy-link">Return &amp; Refund Policy</RouterLink>
                </li>
              </ul>
            </div>
            <div className="footer-column4">
              <h4 class="h4">Newsletter</h4>
              <p>
                Sign up for our newsletter to get updated information, news, and
                free insights.
              </p>
              <div className="newsletter-input-container">
                <input
                  type="email"
                  className="newsletter-input"
                  placeholder="Enter your email"
                />
                <button className="newsletter-button">Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider className="footer-divider" />
      <div className="footer-copyright">
        <div className="copyright-text">
          © {currentYear} cinebooking.lk All rights reserved.
        </div>
        <div className="footer-links">
          {/* <Link href="#" className={classes.footerLink}>
            Term of Use
          </Link>{' '}
          |
          <Link href="#" className={classes.footerLink}>
            Privacy Policy
          </Link>{' '}
          |
          <Link href="#" className={classes.footerLink}>
            Cookie Policy
          </Link> */}
          <Link href="https://www.matrixmantra.lk/">
            Web Design & Development by Matrix Mantra
          </Link>
        </div>
      </div>
    </footer>
  );
}
